import { render, staticRenderFns } from "./TemplateFormDialog.vue?vue&type=template&id=098d5496&scoped=true"
import script from "./TemplateFormDialog.vue?vue&type=script&lang=js"
export * from "./TemplateFormDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateFormDialog.vue?vue&type=style&index=0&id=098d5496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098d5496",
  null
  
)

export default component.exports